import {
  LayoutDashboard,
  UtensilsCrossed,
  Settings,
  Grid3x3,
  Receipt,
  Building2,
  CalendarCheck,
} from 'lucide-react';

/**
 * Admin Menu Configuration (Back Office)
 *
 * PERMISSION FIELD on each item:
 *   item.permission  — the SCREEN code from P.BACK_OFFICE (permissionCodes.js).
 *                      AdminSidebar will call hasPermission(item.permission) and
 *                      hide the item when it returns false.
 *                      Items without a permission field are always visible.
 *
 * Sidebar filtering rules (same as ModuleSidebar):
 *   • item HAS permission  → show only if hasPermission(item.permission) === true
 *   • item has NO permission → always visible
 *   • parent with children → shown only when ≥1 child is visible;
 *                            hidden when ALL children are hidden
 */

// Main navigation menu items
export const menuItems = [
  {
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/admin/dashboard',
    description: 'Overview and analytics',
    permission: 'back_office.dashboard',   // P.BACK_OFFICE.DASHBOARD.SCREEN
  },
  {
    label: 'Bills',
    icon: Receipt,
    path: '/admin/bills-summary',
    description: 'Manage customer bills',
    permission: 'back_office.bills',       // P.BACK_OFFICE.BILLS.SCREEN
  },
  {
    label: 'Day Close',
    icon: CalendarCheck,
    path: '/admin/day-close',
    description: 'End-of-day business close',
    permission: 'back_office.day_close',   // P.BACK_OFFICE.DAY_CLOSE.SCREEN
  },
  {
    label: 'Menus',
    icon: UtensilsCrossed,
    path: '/admin/menu',
    description: 'Manage menu items and categories',
    permission: 'back_office.menu',        // P.BACK_OFFICE.MENU.SCREEN
  },
  {
    label: 'Tables',
    icon: Grid3x3,
    path: '/admin/tables',
    description: 'Manage restaurant tables and sections',
    permission: 'back_office.tables',      // P.BACK_OFFICE.TABLES.SCREEN
  },
];

// Bottom section menu items
export const bottomMenuItems = [
  {
    label: 'Settings',
    icon: Settings,
    path: '/admin/settings',
    description: 'Application settings hub',
    permission: 'back_office.settings',    // P.BACK_OFFICE.SETTINGS.SCREEN
  },
];

// Branding configuration
export const branding = {
  logo: 'Restaurant',
  subtitle: 'Back Office',
  color: 'teal',
};

// Function to get menu items with dynamic badges (from API/state)
export const getMenuItemsWithBadges = (orderCount = 0) => {
  return menuItems.map((item) => {
    if (item.path === '/admin/orders' && orderCount > 0) {
      return { ...item, badge: orderCount.toString() };
    }
    return item;
  });
};